<template>
  <section class="fs" :class="{live: live}" v-if="show">
    <div class="showConfetti" v-on:click="simulateLive" v-if="1>2">
      Simulate going live
    </div>
    <div class="confettiCnt" v-if="showingCoffetti">
      <div class="cEl" id="el1"></div>
      <div class="cEl" id="el2"></div>
      <div class="cEl" id="el3"></div>
      <div class="cEl" id="el4"></div>
      <div class="cEl" id="el5"></div>
      <div class="cEl" id="el6"></div>
      <div class="cEl" id="el7"></div>
      <div class="cEl" id="el8"></div>
    </div>
    <div class="cdl" :class="`bg${bgIdx}`">
      <div class="bgCnt" :class="{zoom: bgZoom}">
        <div class="bg bg1"></div>
        <div class="bg bg2"></div>
        <div class="bg bg3"></div>
      </div>
      <video muted autoplay loop playsinline v-if="1>2">
        <source src="../assets/video/home-video-hd.mp4" type="video/mp4">
        <source src="../assets/video/home-video-md.mp4" type="video/mp4"
          media="all and (max-width:1240px)">
        <source src="../assets/video/home-video-sm.mp4" type="video/mp4"
          media="all and (max-width:980px)">
        <source src="../assets/video/home-video-xs.mp4" type="video/mp4"
          media="all and (max-width:580px)">
      </video>
      <div class="videoFilter"></div>
      <div class="cdlIn">
        <img class="logo" src="../assets/i-lead-logo.png">
        <h4>Portal Putusan Lingkungan Hidup<br /> akan
          <span v-on:click="simulateLive">segera</span> diluncurkan</h4>
        <div class="cdCnt">
          <div class="cdItem">
            <canvas id="c1" ref="c1" width="680" height="680"></canvas>
            <div class="cdLabel">{{cd.d}}<span>Hari</span></div>
          </div>
          <div class="cdItem">
            <canvas id="c2" ref="c2" width="680" height="680"></canvas>
            <div class="cdLabel">{{cd.h}}<span>Jam</span></div>
          </div>
          <div class="cdItem">
            <canvas id="c3" ref="c3" width="680" height="680"></canvas>
            <div class="cdLabel">{{cd.m}}<span>Menit</span></div>
          </div>
          <div class="cdItem">
            <canvas id="c4" ref="c4" width="680" height="680"></canvas>
            <div class="cdLabel">{{cd.s}}<span>Detik</span></div>
          </div>
        </div>
        <button class="add2Calendar" v-on:click="add2Calendar"
          v-if="1>2">Tambah ke Kalender</button>
        <p>Portal Putusan Lingkungan Hidup merupakan sebuah situs yang
          akan menghimpun dokumen, analisis hukum dan pandangan ahli
          terhadap kasus lingkungan hidup terpilih yang diputus di
          pengadilan.<br />Portal ini dibentuk sejak awal tahun 2022.
          Putusan terpilih dalam portal ini diseleksi menurut kriteria
          sebagai putusan yang memuat pertimbangan hakim, argumen
          para pihak, dan/atau pembuktian yang penting untuk menjadi
          pembelajaran bagi perkembangan hukum lingkungan di Indonesia.</p>
      </div>
      <div class="socmedCnt">
        <h4>Follow Us</h4>
        <div class="theSocmed">
          <a href="https://www.instagram.com/icel_indo/"
            target="_blank" class="socmedItem ig"></a>
          <a href="https://twitter.com/icel_indo?s=21"
            target="_blank" class="socmedItem tw"></a>
          <a href="https://youtube.com/c/IndonesianCenterforEnvironmentalLaw"
            target="_blank" class="socmedItem yt"></a>
          <a href="https://id.linkedin.com/company/indonesian-center-for-environmental-law"
            target="_blank" class="socmedItem in"></a>
          <a href="hhttps://www.facebook.com/icel.or.id"
            target="_blank" class="socmedItem fb"></a>
          <a href="https://spoti.fi/3sGdvJP"
            target="_blank" class="socmedItem sp"></a>
        </div>
        <div class="copyright">&copy; {{y}} Indonesian Center for Environmental Law</div>
      </div>
    </div>
    <div class="cdr">
      <div class="cdrIn"></div>
      <div class="cdrFooter">
        <div class="link">
          Link konfirmasi kehadiran <a href="https://bit.ly/Launching-I-LEAD">
          bit.ly/Launching-I-LEAD</a>
        </div>
        <div class="contact">
          Narahubung <a href="">081382777068</a>
          (Official Account ICEL)
        </div>
      </div>
    </div>
    <Add2Calendar ref="add2Calendar"/>
  </section>
</template>

<script>
import Add2Calendar from '@/components/Add2Calendar.vue';

export default {
  name: 'home',
  components: { Add2Calendar },
  data() {
    return {
      y: '',
      cd: {
        d: '--',
        h: '--',
        m: '--',
        s: '--',
      },
      show: true,
      live: false,
      ts: new Date('26 January 2023 08:30:00 +7'),
      df: 50,
      cdInterval: null,
      bgIdx: 1,
      bgZoom: false,
      showingCoffetti: false,
      slidePaused: false,
    };
  },
  methods: {
    add2Calendar() {
      this.$refs.add2Calendar.open();
    },
    degreesToRadians(deg) {
      return (deg / 180) * Math.PI;
    },
    percentToRadians(percentage) {
      const degrees = percentage * 360 / 100;
      return this.degreesToRadians(degrees + 270);
    },
    drawPercentage(percentage, radius, canvas, color) {
      const cv = canvas;
      const context = cv.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      const x = cv.width / 2;
      const y = cv.height / 2;
      const startAngle = this.percentToRadians(0);
      const endAngle = this.percentToRadians(percentage);
      let counterClockwise = true;
      context.beginPath();
      context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
      context.lineWidth = 20;
      context.strokeStyle = 'rgba(255,255,255,0.36)';
      context.stroke();
      counterClockwise = false;
      context.beginPath();
      context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
      context.lineWidth = 20;
      context.strokeStyle = color;
      context.stroke();
    },
    drawCircle(idx, percent) {
      const percentage = percent || 100;
      let radius;
      let theCanvas;
      let color;
      switch (idx) {
        case 1: theCanvas = c1; color = '#2da066'; break;
        case 2: theCanvas = c2; color = '#4a89c9'; break;
        case 3: theCanvas = c3; color = '#7e2b95'; break;
        case 4: theCanvas = c4; color = '#feb91f'; break;
        default: break;
      }
      if (theCanvas.height < theCanvas.width) radius = theCanvas.height / 3;
      else radius = theCanvas.width / 2.5;
      this.drawPercentage(percentage, radius, this.$refs[`c${idx}`], color);
    },
    checkLive() {
      const d = new Date();
      const dst = this.ts.getTime() - d.getTime();
      const d2 = Math.floor(dst / (1000 * 60 * 60 * 24));
      const h2 = Math.floor((dst % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cd.d = (d2 < 10) ? `0${d2.toString()}` : d2.toString();
      this.cd.h = (h2 < 10) ? `0${h2.toString()}` : h2.toString();
      this.cd.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cd.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      const dpr = Math.ceil(-d2 / this.df * 100);
      const hpr = Math.ceil(-h2 / 24 * 100);
      const mpr = Math.ceil(-m2 / 60 * 100);
      const spr = Math.ceil(-s2 / 60 * 100);
      this.drawCircle(1, dpr);
      this.drawCircle(2, hpr);
      this.drawCircle(3, mpr);
      this.drawCircle(4, spr);
      if (dst <= 1000) {
        this.slidePaused = true;
        clearInterval(this.cdInterval);
        // Do somthing when live
        this.showConfetti();
        this.$emit('live');
      }
    },
    simulateLive() {
      const d = new Date();
      d.setSeconds(d.getSeconds() + 11);
      this.ts = d;
    },
    showConfetti() {
      this.showingCoffetti = true;
      setTimeout(() => {
        setTimeout(() => {
          party.confetti(document.getElementById('el1'));
          party.confetti(document.getElementById('el2'));
          party.confetti(document.getElementById('el3'));
          party.confetti(document.getElementById('el8'));
        });
        setTimeout(() => {
          party.confetti(document.getElementById('el2'));
          party.confetti(document.getElementById('el5'));
          party.confetti(document.getElementById('el7'));
        }, 500);
        setTimeout(() => {
          party.confetti(document.getElementById('el4'));
          party.confetti(document.getElementById('el5'));
          party.confetti(document.getElementById('el6'));
          party.confetti(document.getElementById('el2'));
        }, 700);
        setTimeout(() => {
          party.confetti(document.getElementById('el3'));
          party.confetti(document.getElementById('el1'));
        }, 1000);
        setTimeout(() => {
          party.confetti(document.getElementById('el5'));
          party.confetti(document.getElementById('el8'));
          startConfetti();
        }, 2000);
        setTimeout(() => {
          party.confetti(document.getElementById('el2'));
          party.confetti(document.getElementById('el3'));
          party.confetti(document.getElementById('el4'));
          this.live = true;
        }, 3000);
        setTimeout(() => {
          party.confetti(document.getElementById('el1'));
          party.confetti(document.getElementById('el5'));
          stopConfetti();
        }, 5000);
        setTimeout(() => {
          party.confetti(document.getElementById('el2'));
        }, 6000);
        setTimeout(() => {
          party.confetti(document.getElementById('el6'));
        }, 7000);
        setTimeout(() => {
          party.confetti(document.getElementById('el2'));
          party.confetti(document.getElementById('el8'));
        }, 8000);
        // setTimeout(() => {
        //   party.confetti(document.getElementById('el3'));
        // }, 9000);
        setTimeout(() => {
          party.confetti(document.getElementById('el6'));
          removeConfetti();
        }, 10000);
        setTimeout(() => {
          this.show = false;
        }, 10500);
      });
    },
  },
  computed: {
    calUri() {
      const uri = 'https://calendar.google.com/calendar/u/0/r/eventedit?'
        + 'text=Youthfuel Summer Fest'
        + '&dates=20211002T030000.000Z/20211002T100000.000Z'
        + '&ctz=Asia/Jakarta'
        + '&details=Ikuti acara Youthfuel Summer Fest pada 2 Oktober 2021 di '
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&location=${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        // + '&pli=1'
        + '&uid=youthfuelsummerfest';
        // + '&sf=true'
        // + '&output=xml';
      return uri;
    },
    calUri2() {
      const uri = 'https://outlook.live.com/owa/?path=/calendar/action/compose'
        + '&rru=eventable&subject=Youthfuel Summer Fest'
        + '&startdt=20211002T030000.000Z&enddt=20211002T100000.000Z'
        + '&ctz=Asia/Jakarta'
        + '&details=Ikuti acara Youthfuel Summer Fest pada 2 Oktober 2021 di '
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&location=${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + '&uid=youthfuelsummerfest';
      return uri;
    },
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
    if (d.getTime() < this.ts.getTime()) {
      setTimeout(() => {
        this.checkLive();
        this.cdInterval = setInterval(() => {
          this.checkLive();
        }, 1000);
      });
    } else {
      // Do something when live
      this.show = false;
      this.$emit('live');
    }
    setInterval(() => {
      if (this.slidePaused) return;
      this.bgZoom = false;
      if (this.bgIdx === 3) this.bgIdx = 1;
      else this.bgIdx += 1;
      setTimeout(() => {
        this.bgZoom = true;
      });
    }, 3000);
  },
};
</script>

<style scoped lang="scss">
section{
  display: flex;
  color: #555;
  height: 100vh;
  position: absolute;
  left: 0; right: 0; top: 0;
  z-index: 99993;
  &.live{
    transition: all 5s ease;
    opacity: 0;
  }
  @media (max-width: 1200px) {
    display: block;
  }
  .cdl{
    width: 50%;
    height: 100vh;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-image: url(../assets/background-1.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    min-height: 640px;
    .bgCnt{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 1;
      transition: all 2s ease;
      &.zoom{
        // transform: scale(2);
      }
    }
    .bg{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      opacity: 0;
      transition: all 1.5s ease;
      &.bg1{
        background-image: url(../assets/background-1.jpg);
      }
      &.bg2{
        background-image: url(../assets/background-2.jpg);
      }
      &.bg3{
        background-image: url(../assets/background-3.jpg);
      }
    }
    &.zoom1{
      .bg{
        transform: scale(2);
      }
    }
    &.zoom2{
      .bg{
        transform: scale(2);
      }
    }
    &.zoom3{
      .bg{
        transform: scale(2);
      }
    }
    &.bg1 .bg1{
      opacity: 1;
    }
    &.bg1 .bg2{
      opacity: 1;
    }
    &.bg1 .bg3{
      opacity: 1;
    }
    video{
      min-width: 100%; min-height: 100%;
      width: auto; height: auto;
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
    }
    .videoFilter{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 2;
      // backdrop-filter: saturate(160%);
      // display: none;
      background-color: rgba(0, 0, 0, .2);
    }
    @media (max-width: 1200px) {
      width: auto; height: auto;
      display: block;
    }
    .add2Calendar{
      border: #fff 1px solid;
      color: #fff;
      background: no-repeat;
      padding: 10px 20px;
      border-radius: 5px;
      margin: 0 0 20px;
      font-size: 16px;
      cursor: pointer;
      transition: all .3s ease;
      backdrop-filter: blur(75px);
      &:hover{
        background-color: rgba(0, 0, 0, .1);
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      }
    }
    .cdlIn{
      // padding-bottom: 120px;
      position: relative;
      z-index: 3;

      padding-bottom: 120px;
      @media (max-width: 1200px) {
        // padding: 120px 20px;
        padding: 0 40px 200px;
      }
      @media (max-width: 760px) {
        padding: 0 16px 140px;

      }
      .logo{
        height: 56px;
        margin: 0 0 40px;
        @media (max-width: 1480px) {
          height: 46px;
        }
      }
      h4{
        color: #fff;
        font-size: 46px;
        margin: 0 0 20px;
        line-height: 1.1;

        line-height: 1.2;
        @media (max-width: 1480px) {
          font-size: 36px;
          font-size: 30px;
        }
        @media (max-width: 680px) {
          font-size: 22px;

          line-height: 1.4;
        }
      }
      .cdCnt{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        // font-family: 'Inter', sans-serif;
        @media (max-width: 1480px) {
          padding: 4px 0 14px;
        }
        .cdItem{
          position: relative;
          canvas{
            width: 160px; height: 160px;
            @media (max-width: 1480px) {
              width: 140px; height: 140px;
            }
            @media (max-width: 680px) {
              width: 84px; height: 84px;
            }
          }
          .cdLabel{
            position: absolute;
            left: 0; right: 0; top: 38px;
            text-align: center;
            color: #fff;
            font-weight: 800;
            font-size: 48px;
            @media (max-width: 1480px) {
              font-size: 36px;
            }
            @media (max-width: 680px) {
              font-size: 24px;
              top: 20px;
            }
            span{
              display: block;
              font-size: 18px;
              margin-top: -4px;
              @media (max-width: 1480px) {
                font-size: 16px;
              }
              @media (max-width: 680px) {
                font-size: 10px;
                margin-top: -3px;
              }
            }
          }
        }
      }
      p{
        color: #fff;
        margin: 0 auto;
        max-width: 640px;

        line-height: 1.4;
        max-width: 760px;
        padding: 0 20px;
        @media (max-width: 1480px) {
          font-size: 14px;
          // max-width: 580px;
        }
        @media (max-width: 760px) {
          padding: 0;
        }
        @media (max-width: 680px) {
          font-size: 14px;
        }
      }
    }
  }
  .cdr{
    width: 50%;
    height: 100vh;
    position: relative;
    background-color: #f5f0dd;
    min-height: 640px;
    @media (max-width: 1200px) {
      width: auto; height: 76vw;
      display: block;
    }
    @media (max-width: 960px) {
      height: 86vw;
    }
    @media (max-width: 760px) {
      height: 96vw;
    }
    @media (max-width: 680px) {
      height: 140vw;
    }
    .cdrIn{
      position: absolute;
      top: 10px; left: 20px; right: 20px; bottom: 40px;
      background-image: url(../assets/i-lead-launching.jpg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 1400px) {
        bottom: 60px;
      }
    }
    .cdrFooter{
      position: absolute;
      left: 0; right: 0; bottom: 0;
      padding: 12px 20px 10px;
      display: flex;
      background-color: #8c6238;
      color: #fff;
      font-size: 14px;
      @media (max-width: 1400px) {
        display: block;
        text-align: center;
        font-size: 15px;
      }
      @media (max-width: 1200px) {
        display: flex;
      }
      @media (max-width: 760px) {
        display: block;
        font-size: 14px;
      }
      a{
        color: #fff;
        font-weight: 600;
      }
      .link{
        margin-right: auto;
        @media (max-width: 1400px) {
          margin: 0 0 2px;
        }
        @media (max-width: 1200px) {
          margin: 0;
          margin-right: auto;
        }
        @media (max-width: 760px) {
          margin: 0 0 2px;
        }
      }
    }
  }
  .socmedCnt{
    position: absolute;
    left: 50%; bottom: 10px;
    transform: translateX(-50%);
    text-align: center;
    z-index: 4;
    // display: none;
    @media (max-width: 1200px) {
      // display: none;
    }
    &.mobile{
      display: none;
      @media (max-width: 1200px) {
        position: relative;
        left: auto; bottom: auto;
        transform: none;
        // display: block;
        padding-bottom: 16px;
      }
    }
    &:before{
      content: "";
      height: 3px;
      top: -30px;
      left: 100px; right: 100px;
      position: absolute;
      background-color: #fff;
      border-radius: 50px;
      opacity: .36;
      @media (max-width: 1480px) {
        // background-color: #000;
        // opacity: .1;
        display: none;
        left: auto; right: auto;
        width: 100px;
        transform: translateX(-50%);
      }
      @media (max-height: 780px) {
        display: none;
      }
    }
    h4{
      margin: 0 0 16px;
      color: #fff;
      // font-family: 'Inter', sans-serif;
      @media (max-width: 1480px) {
        font-size: 14px;
      }
    }
    .theSocmed{
      display: flex;
      justify-content: center;
      margin: 0 0 20px;
      .socmedItem{
        width: 40px; height: 40px;
        margin: 0 5px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        transition: all .3s ease;
        opacity: .76;
        border-radius: 50%;
        @media (max-width: 1480px) {
          width: 34px; height: 34px;
          margin: 0 4px;
        }
        @media (max-width: 1200px) {
          // filter: invert(1);
          // opacity: .36;
        }
        &:hover{
          opacity: 1;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          @media (max-width: 1200px) {
            opacity: .65;
          }
        }
        &.ig{
          background-image: url(../assets/ic-instagram.png);
        }
        &.fb{
          background-image: url(../assets/ic-facebook.png);
        }
        &.in{
          background-image: url(../assets/ic-linkedin.png);
        }
        &.sp{
          background-image: url(../assets/ic-spotify.png);
        }
        &.tw{
          background-image: url(../assets/ic-twitter.png);
        }
        &.yt{
          background-image: url(../assets/ic-youtube.png);
        }
      }
    }
    .copyright{
      color: #fff;
      font-size: 13px;
      opacity: .65;
      // display: none;
      @media (max-width: 1480px) {
        // color: #767676;
      }
    }
  }
  .showConfetti{
    background-color: red;
    color: #fff;
    border-radius: 50%;
    width: 80px; height: 80px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 20px; top: 20px;
    line-height: 1.1;
    padding: 10px;
    z-index: 99997;
    cursor: pointer;
    // display: none;
  }
  .confettiCnt{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 99997;
    .cEl{
      position: absolute;
      width: 20px; height: 20px;
      &#el1{
        left: 40px; top: 40px;
      }
      &#el2{
        left: 160px; top: 160px;
      }
      &#el3{
        left: 50%; top: 50%;
      }
      &#el4{
        right: 40px; top: 100px;
      }
      &#el5{
        right: 20px; bottom: 40px;
      }
      &#el6{
        right: 40%; bottom: 60%;
      }
      &#el7{
        right: 30%; bottom: 50%;
      }
      &#el8{
        right: 60%; bottom: 46%;
      }
    }
  }
  &.fs{
    display: block;
    min-height: 700px;
    @media (max-width: 680px) {
      min-height: 740px;
    }
    .cdl{
      width: auto;
      height: 100% !important;
      @media (max-width: 1200px) {
        display: flex;
      }
    }
    .cdr{
      display: none;
    }
  }
}
</style>
